import { render } from "./EventCreate.vue?vue&type=template&id=209df008"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"
script.render = render

export default script